export default __webpack_public_path__ + "electric.mp3";